"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parser_1 = require("./parser");
const interpreter_1 = require("./interpreter");
const manager_1 = require("./manager");
exports.entry = (text) => {
    const ast = parser_1.parseInput(text);
    try {
        const manager = {
            variable: new manager_1.VariableManager(null),
            function: new manager_1.FunctionManager(),
        };
        interpreter_1.interpreter({ ast, execObject: { manager, interpreter: interpreter_1.interpreter } });
        manager.variable.debug();
        manager.function.debug();
        // const rAst = removeObjectByKey(ast, UnnecessaryKeys);
        // writeAstToJson(rAst as any);
    }
    catch (err) {
        console.error(err);
    }
};
